import { Rule } from "components/Order/Form/Settings/OrderProcessingRules/OrderProcessingRules";
import { apiGateway, api } from "../config";
import {IModuleSettings} from "../../redux/orders/reducer";

class ordersService {

    async addNewUpdToOrder<T>(data: T) {
        console.log('Add new upd to order', JSON.stringify(data));

        return api(apiGateway.orders + '/upd/add', {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    validateUpdToOrder<T>(data: T) {
        console.log('Add new upd to order', JSON.stringify(data));

        return api(apiGateway.orders + '/upd/validation', {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: {xmlString: data}
        })
    }

    deleteUpd(id: number) {
        return api(`${apiGateway.orders}/upd/${id}`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
            }
        })
    }

    getUpdListByOrderID(id: number|null) {
        return api(`${apiGateway.orders}/${id}/upd/list`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
            }
        })
    }

    getStickersByOrderID(order_id: number|null) {
        return api(`${apiGateway.sticker}/order/${order_id}/stickers`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
            }
        })
    }

    getSellerOrdersProcessingRules(sellerId: number) {
        return api(`${apiGateway.orders}/processing-rules/${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Accept": "application/json",
            }
        })
    }

    getSellerOrdersProcessingRulesFulfillment(sellerId: number) {
        return api(`${apiGateway.orders}/processing-rules/fulfillment/${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Accept": "application/json",
            }
        })
    }

    getModuleSettingsForSeller(sellerId: number) {
        return api(`${apiGateway.orders}/settings/${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Accept": "application/json",
            }
        })
    }

    getSellerOrdersByOrderList(sellerId: number[], ordersList: string[], fields: string[]) {
        return api(`${apiGateway.legacyPublicAPIv3}/orders`, {
            method: "POST",
            headers: {
                Accept:         "application/json",
                "Content-Type": "application/json",
            },
            data: {
                sellers: sellerId,
                ordersList: ordersList,
                fields: fields
            }
        })
    }


    updateSellerOrdersProcessingRules<T>(sellerId: number, data: Rule[]) {
        return api(apiGateway.orders + `/processing-rules/${sellerId}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    updateSellerOrdersProcessingRulesFulfillment<T>(sellerId: number, data: Rule[]) {
        return api(apiGateway.orders + `/processing-rules/${sellerId}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    updateModuleSettings<T>(sellerId: number, data: IModuleSettings) {
        return api(apiGateway.orders + `/settings/${sellerId}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

}

export default new ordersService();